export default "__VITE_ASSET__DtS9_3r1__"